import React, { Component } from 'react';

import { connect } from 'react-redux'
import { teachersActions } from '../actions';
import { notebookActions } from '../notebookActions';
import { Spinner } from 'components/Icons/Spinner';

import { CourseSubjectHeader } from '../components/CourseSubjectHeader';

import { Row, Col, Card, CardBody } from "reactstrap";

import { NotebookCell } from '../components/notebook/NotebookCell';

// import './styles.css'
var Utils = require ('Utils');
var viewActions = require ('store/view.actions');


class CourseSubjectCalif extends Component {

    constructor(props) {
      super(props);
      this.state = {
        modalOpen: false,
        currentCalif: {} 
       };
    }

    setModalOpen ( st ) {
        this.setState({ modalOpen: st }) ;
    }


    getRows() {
        
        return this.props.courseStudents.map( (student) => {
 
          
          let filtra = this.props.notebookItems.filter( c => c.persona_id === student.persona_id) ;
 
          let obj = filtra.map( (i) => {
                // i.studentName =  Utils.capitalize( student.last_name + ", " + student.name );
                return {...i, name : Utils.capitalize( student.last_name + ", " + student.name ) };
          })

          obj.push( {studentName: Utils.capitalize( student.last_name + ", " + student.name ), 
                        tool_id: 'studentName', persona_id : student.persona_id } );

           return obj; 
        })

      }

    getColumns ( ) {
        // Loop por las herramientas de la materia
       
        let columns = [] ;
        this.props.notebookTools.map( tool => {
            columns.push(
                          { 
                              width: "150" , 
                              title: tool.short_name, 
                              alt: tool.name,
                              field: tool.tool_id,
                              // blocked: ev.blocked,
                              tool: tool
                          } 
            );
            return null;
        } );
        columns.unshift({ width: '300', title: 'Alumno', field: 'studentName' });
        return columns ;
      }


    componentDidMount() {

        this.props.getCourseSubject (this.props.token,  this.props.match.params.course_subject_id) ;
        this.props.getCourseSubjectStudents (this.props.token,  this.props.match.params.course_subject_id) ;
        
        //
        this.props.getCourseSubjectTools (this.props.token,  this.props.match.params.course_subject_id) ;

        this.props.getCourseSubjectNotebookItems (this.props.token,  this.props.match.params.course_subject_id);
        this.props.setBreadCrumb(
                    [{title:'Mis Cursos', link:'/admin/my-courses'},
                     {title: 'Datos del curso', link:'/admin/my-courses/'+this.props.match.params.course_subject_id}
                    ], 'Cuaderno del profesor')
    }

    setCalif( calif, col, student, evaluationID ) {
        this.setState({currentCalif: {calif: calif, col: col, student: student, evaluationID: evaluationID }  })
        this.setModalOpen(!this.state.modalOpen) ;

    }

    render() {

        return ( 
            <>
            
            <div className="content">
            {  this.props.courseSubject && 
               this.props.courseSubject.schedule &&
            //  this.props.courseEvals.evaluations  && 
               this.props.notebookItems && 
               this.props.courseStudents && 
             !this.props.view.loadingModules.getCourseSubject 
            ?
               <Card>
                    <CourseSubjectHeader 
                        courseSubject={this.props.courseSubject}
                        coverImage="https://alumni-images.s3.us-east-2.amazonaws.com/subjects/covers/notebook-cover.jpg"
                        />

                   <CardBody>
                        <Row>
                            <Col sm="12">
                            <div class="table-wrapper">
                                <table>
                                    <tbody>
                                        <tr className='fixed-th '>
                                        {/* CABECERA DE LA TABLA */}
                                         { this.getColumns().map((col,idx) => {
                                            return(
                                                <>
                                                    <td width={col.width} align="center" key={col.field} 
                                                       >
                                                        <div title={col.alt} >
                                                            {/* <b>{col.title}</b> */}
                                                            {col.alt}
                                                        </div>
                                                    </td> 
                                                </> 
                                            )
                                        }) }
                                        
                                        </tr>
                                       
                                        {  this.getRows().map((row,idx) => {
                                            let persona = (row.find( (r) => r.tool_id === 'studentName'));
                                            return(
                                                <>
                                                <tr bgcolor={idx%2===0?"#f0f0f0":""} >
                                                    { this.getColumns().map((col) => {
                                                        return ( 
                                                            <td width="100" style={{border: "1px solid"}}> 
                                                                <NotebookCell 
                                                                    col = {col}
                                                                    row = {row}
                                                                    persona = {persona}
                                                                    updateItem = {this.props.addCourseSubjectNotebookItem}
                                                                    courseSubjectID = {this.props.courseSubject.course_subject_id}
                                                                    token = {this.props.token}
                                                                />
                                                            </td>
                                                        )
                                                    }) }
                                                </tr>
                                                </>
                                            )

                                            })}

                                            
                                    </tbody>
                                </table>
                            </div>
                            </Col>
                        </Row>
                    </CardBody> 

                </Card> 
            :
            <Spinner size="XL" />
          }

            </div>
       </>
        
            );
    }

}

const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID: state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user,
        courseSubject: state.teachers.courseSubject,
        courseStudents: state.teachers.courseStudents,
        notebookTools: state.teachers.notebookTools,
        notebookItems: state.teachers.notebookItems
    }
}

    
const mapDispatchToProps = dispatch => {
    return { 
        
        getCourseSubject: (token, courseSubjectID) => {
            dispatch(teachersActions.getCourseSubject(token, courseSubjectID));
        } , 
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        setBreadCrumb: ( breadCrumb, activeTitle ) => {
            dispatch(viewActions.setBreadCrumb( breadCrumb, activeTitle ))
          },
  
        getCourseSubjectTools: (token, courseSubjectID) => {
            dispatch(notebookActions.getCourseSubjectTools(token, courseSubjectID));
        } , 
       
        getCourseSubjectNotebookItems: (token, courseSubjectID ) => {
            dispatch(notebookActions.getCourseSubjectNotebookItems(token, courseSubjectID));
        } ,

        getCourseSubjectStudents: (token, courseSubjectID ) => {
          dispatch(teachersActions.getCourseSubjectStudents(token, courseSubjectID));
        },
        addCourseSubjectNotebookItem: ( token, courseSubjectID, personaID,  toolID,  evalTypeOptID, evalTypeValue , comments ) => {
            dispatch(notebookActions.addCourseSubjectNotebookItem ( token, courseSubjectID, personaID,  
                                toolID,  evalTypeOptID, evalTypeValue , comments ));
        }


        // updateCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID, data, qualifValue ) => { 
        //     dispatch( teachersActions.updateCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, data, qualifValue ) )
        // },
        // addCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID, qualifValue ,qualifValueNbr,  comments ) => {
        //     dispatch( teachersActions.addCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, qualifValue,qualifValueNbr , comments ))
        // },
        // deleteCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID ) => { 
        //     dispatch( teachersActions.deleteCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID ) )
        // }


    }
}

    export default connect(mapStateToProps, mapDispatchToProps)(CourseSubjectCalif);